<div class="phx-date-picker-menu-list">
  <ul class="phx-date-picker-menu-items">
    <li
      *ngFor="let item of menuItems; let i = index"
      class="phx-date-picker-menu-item"
      role="button"
      type="button"
      phxFocusableItem
      [class.selected]="i === selectedItemIndex"
      (click)="selectItem(item, i)"
      (keydown)="onMenuKeydown($event, item, i)"
    >
      {{ item.label }}
    </li>
  </ul>
</div>
